import { useStaticQuery, graphql } from 'gatsby'

const calendarLimitQuery = graphql`
  query calendarLimitQuery {
    datoCmsRental {
      calendarLimit(formatString: "YYYY-MM-DD")
    }
  }
`

export default function useCalendarLimit () {
  const {
    datoCmsRental: {
      calendarLimit
    }
  } = useStaticQuery(calendarLimitQuery)

  return calendarLimit
}
